const Steps = [
    {
        index: 0,
        label: 'lang_upload_id_photo',
    },
    {
        index: 1,
        label: 'EKYC',
    },
    {
        index: 2,
        label: 'lang_personal_information',
    },
    {
        index: 3,
        label: 'lang_employment_information',
    },
    {
        index: 4,
        label: 'lang_financial_and_investment',
    },
    {
        index: 5,
        label: 'lang_identity_disclosures_and_tax_information',
    },
    {
        index: 6,
        label: 'lang_account_type',
    },
    {
        index: 7,
        label: 'lang_risk_disclosure',
    },
    {
        index: 8,
        label: 'lang_esignature',
    },
    {
        index: 9,
        label: 'lang_make_a_deposit',
    },
]

export default Steps